(function () {
  const SECTION_SELECTOR = '[data-recommendations-section]';

  function initAll(root) {
    root.querySelectorAll(SECTION_SELECTOR).forEach((section) => initSection(section));
  }

  function initSection(section) {
    if (section.dataset.recommendationsInitialized === 'true') return;
    section.dataset.recommendationsInitialized = 'true';

    const scroller = section.querySelector('[data-scroll-container]');
    const controls = {
      left: section.querySelector('[data-fade="left"]'),
      right: section.querySelector('[data-fade="right"]'),
    };

    if (scroller) {
      const scrollAmount = () => Math.min(scroller.clientWidth * 0.9, 480);

      const updateFade = () => {
        const maxScroll = scroller.scrollWidth - scroller.clientWidth;
        if (maxScroll <= 4) {
          toggleControl(controls.left, false);
          toggleControl(controls.right, false);
          return;
        }
        const offset = scroller.scrollLeft;
        toggleControl(controls.left, offset > 4);
        toggleControl(controls.right, offset < maxScroll - 4);
      };

      scroller.addEventListener('scroll', throttle(updateFade, 100));
      window.addEventListener('resize', debounce(updateFade, 150));
      updateFade();

      if (controls.left) {
        controls.left.addEventListener('click', () => {
          scroller.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
        });
      }

      if (controls.right) {
        controls.right.addEventListener('click', () => {
          scroller.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
        });
      }
    }
  }

  function toggleControl(element, state) {
    if (!element) return;
    element.classList.toggle('is-visible', state);
    element.disabled = !state;
    element.setAttribute('aria-hidden', state ? 'false' : 'true');
  }

  function throttle(callback, delay) {
    let waiting = false;
    return (...args) => {
      if (waiting) return;
      waiting = true;
      requestAnimationFrame(() => {
        callback.apply(this, args);
        setTimeout(() => (waiting = false), delay);
      });
    };
  }

  function debounce(callback, delay) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => callback.apply(this, args), delay);
    };
  }

  document.addEventListener('DOMContentLoaded', () => initAll(document));
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
